import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformSwiftIdApplicationStatus } from './swift-id-application-status.transformer';
import type { SwiftIdApplicationStatusCollection } from './swift-id-application-status.types';

export function swiftIdApplicationStatusReducer(
  state: CollectionStateSlice<SwiftIdApplicationStatusCollection> = {},
  action: CollectionActions<SwiftIdApplicationStatusCollection>,
): CollectionStateSlice<SwiftIdApplicationStatusCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'swiftIdApplicationStatus') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<SwiftIdApplicationStatusCollection>(
          state,
          transformIntoDocuments(result, transformSwiftIdApplicationStatus),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
